import {LANG_ES, langObj, PS_SHOPID_ES, PS_SHOPID_FR, PS_SHOPID_IT} from "../../constants";

export default function getLangByShopId (shopId) {
    return langObj[shopId] ? langObj[shopId] : LANG_ES;
}

export function isSpanishUser (shopId) {
    return shopId != PS_SHOPID_FR && shopId != PS_SHOPID_IT
}
